import { EntityTypeOld, ErrorStateOld } from "Store/interfaces/products";

export interface FindVehicleData {
  readonly licensePlateNumber: string;
  readonly customerRef: string;
  readonly onSuccess?: (data: VehicleInfo) => void;
}

export interface VehicleInfo {
  readonly configurationId: number;
  readonly canBeBoughtOnline: boolean;
  readonly regNumber: string;
  readonly brand: string;
  readonly model: string;
  readonly modelType?: string;
  readonly registrationYear: number;
  readonly kw: number;
  readonly volume: number;
  readonly warrantyType: WarrantyType;
  readonly tfaCode: string;
  readonly companyCode?: number;
  readonly guaranteeOwnerId?: string;
}

export enum WarrantyType {
  OWNER_CHANGE = "OWNER_CHANGE",
  COMPANY_CHANGE = "COMPANY_CHANGE",
  UNCERTAINTY = "UNCERTAINTY",
}

export type FindVehicleEntity = EntityTypeOld<VehicleInfo, OperationType>;

export type FindVehicleError = ErrorStateOld<OperationType>;

export enum OperationType {
  FIND_VEHICLE = "FIND_VEHICLE",
}
